import mainStore from '@/store';
import modelsStore from '@/lib/services/models-store';

import FlowManager from '@/lib/models/flow-manager';

const createService = () => new FlowManager(
  mainStore,
  modelsStore,
);
export default createService();
